import { useTheme as useNextTheme } from 'next-themes';

/**
 * 主题管理 Hook
 * 
 * 直接使用 next-themes 的 useTheme Hook，提供完整的主题切换功能。
 * 
 * 功能：
 * - 支持三种主题模式：`light`、`dark`、`system`
 * - 自动同步到 localStorage
 * - 自动应用主题到 HTML 元素（通过 `.dark` 类）
 * - 监听系统主题变化（当使用 `system` 模式时）
 * - 防止主题闪烁（FOUC）
 * 
 * 参考：
 * - https://ui.shadcn.com/docs/theming
 * - https://github.com/pacocoursey/next-themes
 */
export function useTheme() {
  const { theme, setTheme, resolvedTheme, systemTheme } = useNextTheme();

  /**
   * 切换主题（在 light 和 dark 之间切换，跳过 system）
   */
  const toggleTheme = () => {
    const current = resolvedTheme || 'light';
    setTheme(current === 'light' ? 'dark' : 'light');
  };

  return {
    theme,
    resolvedTheme,
    systemTheme,
    setTheme,
    toggleTheme,
  };
}

